import '../App.css';
import QuestionAutism from '../components/QuestionAutism';
import { useState, useRef, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

function App() {
  const questions = [
      { question: "1. När jag talar med andra har jag svårt för att förstå hur de känner sig" },
      { question: "2. Vissa vardagliga material (som inte stör andra) upplever jag som väldigt obehagliga när de berör huden." },
      { question: "3. Jag har väldigt svårt för att klara grupparbeten och att fungera i grupp." },
      { question: "4. Det är svårt att föreställa sig vad andra förväntar sig av mig." },
      { question: "5. Jag vet ofta inte hur jag ska bete mig i sociala situationer." },
      { question: "6. Jag är bra på att småprata och kallprata med folk." },
      { question: "7. När jag känner mig överväldigad av intryck behöver jag få vara för mig själv och stänga dem ute." },
      { question: "8. Hur man skaffar sig vänner och hur man umgås socialt är obegripligt för mig." },
      { question: "9. I samtal med någon har jag svårt att veta när det är min tur att tala eller lyssna." },
      { question: "10. Ibland måste jag hålla för öronen för att utestänga obehagliga ljud (t ex. dammsugare eller för mycket prat eller för högljudda samtal)." },
      { question: "11. Det kan vara väldigt svårt att avläsa en persons ansiktsuttryck, gester eller kroppsspråk samtidigt som personen talar." },
      { question: "12. Jag fokuserar mer på detaljerna än helheten." },
      { question: "13. Jag uppfattar saker för bokstavligt vilket gör att jag ofta missförstår vad andra menar." },
      { question: "14. Jag blir extremt upprörd när det sätt som jag föredrar att göra saker och ting på, plötsligt ändras." },
  ];

  const [scores, setScores] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [answers , setAnswers] = useState([]);
  const [error , setError] = useState('');
    const wrapperRef = useRef();
    const lastSentHeight = useRef(0);

    const sendHeight = useCallback(() => {
        const newHeight = wrapperRef.current?.scrollHeight;
        if (
            newHeight &&
            Math.abs(newHeight - lastSentHeight.current) > 20
        ) {
            window.parent.postMessage(
                {
                    type: "setHeight",
                    height: newHeight,
                    isSubmitted: isSubmitted,
                },
                "*"
            );
            lastSentHeight.current = newHeight;
        }
    }, [isSubmitted]);

    useEffect(() => {
        function handleResize() {
            sendHeight();
        }
        window.addEventListener('resize', handleResize);
        // Send initial height
        sendHeight();
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [sendHeight]);
    const navigate = useNavigate();
  

  const handleAnswer = (question, points, index) => {
    setScores((prevScores) => ({
        ...prevScores,
        [question]: points,
    }));

     setAnswers((prevAnswers) => {
        if (!prevAnswers.includes(index)) {
            return [...prevAnswers, index];
        }
        return prevAnswers;
    });
};


  const handleSubmit = () => {
     if (answers.length !== questions.length) {
        setError("Du måste svara på alla frågor innan du kan skicka in testet.");
        return;
    }
       setIsSubmitted(true);
      localStorage.setItem('scoresAutism', JSON.stringify(scores));
        setTimeout(() => {
            navigate("/autismResult", { state: { scores } });
        }, 300);
  };

  return (
      <div className="App" ref={wrapperRef}>
          <header className="App-header">
                <>
                  <div className="questionnaire">
                      {questions.map((q, index) => (
                          <QuestionAutism
                              key={index}
                              question={q.question}
                              index={index}
                              onAnswer={handleAnswer}
                          />
                      ))}
                        {error && <p className="error">{error}</p>}
                        <div className='submit-container'>
                            <button onClick={handleSubmit} className="submit-button">
                                Tolka mina svar
                            </button>
                        </div>
                  </div>
                </>
          </header>
      </div>
  );
}

export default App;
